import ApiService from "../api";

/** Usado pelo formulário de Cadastro de Cliente para popular o combo de SubCanal (só os ativos). */
export default class SubCanalAtivoService extends ApiService {

    constructor() {
        super('/api/solicitacoes/config/subcanais')
    }

    listarAtivos() {
        return this.get("/ativos");
    }
}
